import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MobileNav from '../components/MobileNav';
import logo from '../assets/images/wordb_logo.svg';
import { FaArrowRight } from "react-icons/fa";
import { FaRankingStar } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
import Footer from '../components/Footer';
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { MdLogout } from "react-icons/md";
import { toast } from 'react-toastify';
import { API } from '../config';


const HomePage = ({ onLogout }) => {
    const navigate = useNavigate();

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);
    const [isStartingGame, setIsStartingGame] = useState(false);

    const handleSinglePlayer = async () => {
        setIsStartingGame(true);
        try {
            const token = localStorage.getItem('authToken');
            //console.log(token);
            const response = await axios.post(
                `${API}/api/game/start-single-player`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            navigate(`/game/${response.data.roomId}`);
        } catch (error) {
            console.error('Error starting single-player game:', error);
            toast.error('Failed to start game. Please try again.');
            if (error.response && error.response.status === 401) {
                // Token expired or invalid → log out
                localStorage.removeItem('authToken');
                navigate('/');    // redirect to login
            }
        } finally {
            setIsStartingGame(false);
        }
    };

    const handleMultiplayer = () => {
        navigate('/lobby1');
    };

    const handleLogout = () => {
        onLogout?.();              // updates App state + clears token
        toast.info('Logged out');
        navigate('/');            // sends them to login
    };

    return (
        <>
            <section className='home'>

                {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
                {isQueryOpen && <Query onClose={toggleQuery} />}

                <span className='logout-btn left-icon-link'  onClick={handleLogout} title='Log out'>
                    <MdLogout className='icon' />
                </span>

                <MobileNav />       

                <div className="logo-div">
                    <img src={logo} alt="" />
                </div>

                <div className="home-content">
                    <button className='btn quick-play-btn' onClick={handleSinglePlayer}>
                        <span>{ isStartingGame ? 'Starting game...' : 'Play Now'}</span>
                        <FaPlay className='icon'/>
                    </button>

                    <button className='btn multiplayer-btn' onClick={handleMultiplayer}>
                        <span>Multiplayer</span>
                        <FaPlay className='icon'/>
                    </button>

                    <button className='btn leaderboard-btn' onClick={() => navigate('/leaderboard')}>
                        <span>Leaderboard</span>
                        <FaRankingStar className="icon"/>
                    </button>

                    <button className='btn btn-prof' onClick={() => navigate('/profile')}>
                        <span>Your Profile</span>
                        <FaArrowRight className="icon"/>
                    </button>
                </div>
            </section>

            <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
        </>
    );
};

export default HomePage;
